
var WidgetEvents = {
    STEMS_ON_CHANGE: "stems.change",
    SIMPLE_LIST_REMOVE: "simple-list.remove",
    CALENDAR_CHANGED: "calendar.change",
    MODAL_ACTION_CLICKED: "modal.action.clicked",
    ON_SUCCESS: "stems.success"
}

var Widgets = {
    Modal: {
        GlobalErrorSelector: "#globalErrorModal",
        showError: function () {
            $(Widgets.Modal.GlobalErrorSelector).modal("show");
        }
    }
}